export const setAlert = (open, type="success", message="") => {
    return { type: "SET_ALERT", payload: {open, type , message} };
}